<template>
    <div
        v-if="visible"
        class="fixed inset-0 z-[10001] flex items-center justify-center bg-black bg-opacity-50"
        @click.self="$emit('cancel')"
    >
        <div class="bg-white rounded-lg shadow-xl max-w-lg w-full mx-4">
            <div class="px-6 py-4 border-b border-gray-200">
                <h3 class="text-lg font-medium text-gray-900">
                    {{ title }}
                </h3>
            </div>

            <div class="px-6 py-4">
                <div v-if="loading" class="text-center py-6 text-gray-500">
                    Checking current usage&hellip;
                </div>

                <div v-else>
                    <p class="text-sm text-gray-700 mb-3">
                        <strong>{{ blockName }}</strong> is currently used on
                        <strong>{{ count }}</strong>
                        {{ count === 1 ? 'canvas' : 'canvases' }}
                        {{ scopeDescription }}.
                    </p>

                    <p v-if="count > 0" class="text-sm text-gray-600 mb-3">
                        Existing placements will continue to render on the public website — only new additions will be blocked.
                    </p>

                    <div v-if="sample.length" class="mt-3 border border-gray-200 rounded-md">
                        <div class="px-3 py-2 bg-gray-50 text-xs font-medium text-gray-500 border-b border-gray-200">
                            Sample placements (up to {{ sample.length }} shown)
                        </div>
                        <ul class="divide-y divide-gray-100 max-h-48 overflow-auto">
                            <li v-for="(row, idx) in sample" :key="idx" class="px-3 py-2 text-xs">
                                <div class="text-gray-800">
                                    {{ row.page_title || row.canvas_tag || 'Canvas #' + row.canvas_id }}
                                </div>
                                <div v-if="row.context_label" class="text-gray-400">
                                    {{ row.context_label }}
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="px-6 py-4 bg-gray-50 rounded-b-lg flex justify-end gap-3">
                <button
                    type="button"
                    class="px-4 py-2 text-sm bg-white border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                    @click="$emit('cancel')"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    :disabled="loading"
                    class="px-4 py-2 text-sm bg-red-600 text-white rounded-md hover:bg-red-700 disabled:opacity-50"
                    @click="$emit('confirm')"
                >
                    {{ confirmLabel }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BlockUsageWarningModal',

    props: {
        visible: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        title: { type: String, default: 'Confirm exclusion' },
        blockName: { type: String, default: '' },
        count: { type: Number, default: 0 },
        sample: { type: Array, default: () => [] },
        scopeDescription: { type: String, default: '' },
        confirmLabel: { type: String, default: 'Confirm' },
    },
};
</script>
